import React, { useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Auth.css";

function ResetPasswordForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: location.state?.email || "",
    code: "",
    newPassword: "",
    confirmPassword: ""
  });

  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;

    setFormData({
      ...formData,
      [name]: value
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");

    if (formData.newPassword !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setSubmitting(true);

      await axios.post("/api/auth/reset-password", {
        email: formData.email,
        code: formData.code,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword
      });

      navigate("/login", {
        state: {
          message:
            "Your password has been reset successfully. Please log in with your new password."
        }
      });
    } catch (err) {
      console.error("Reset password error:", err);

      if (err.response && err.response.data) {
        setError(
          typeof err.response.data === "string"
            ? err.response.data
            : err.response.data.message || "Something went wrong. Please try again."
        );
      } else {
        setError("Could not connect to backend. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-info-panel">
          <div className="auth-brand">
            <span className="auth-brand-icon">♥</span>
            <span>Tajne Mysli</span>
          </div>

          <h1>Set a new password</h1>

          <p>
            Enter the verification code we sent to your email, along with
            your new password.
          </p>

          <div className="auth-feature-list">
            <div className="auth-feature">
              <span>1</span>
              <p>Check your email for the code</p>
            </div>

            <div className="auth-feature">
              <span>2</span>
              <p>Choose a strong new password</p>
            </div>

            <div className="auth-feature">
              <span>3</span>
              <p>Log back in and keep chatting</p>
            </div>
          </div>
        </div>

        <div className="auth-card">
          <div className="auth-card-header">
            <h2>Reset password</h2>
            <p>Enter the code from your email and set a new password.</p>
          </div>

          {error && <div className="auth-message auth-error">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your account email"
                required
              />
            </div>

            <div className="auth-field">
              <label htmlFor="code">Verification code</label>
              <input
                id="code"
                type="text"
                name="code"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={formData.code}
                onChange={handleChange}
                placeholder="Enter the 6-digit code"
                maxLength={6}
                required
              />
            </div>

            <div className="auth-field">
              <label htmlFor="newPassword">New password</label>
              <input
                id="newPassword"
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="Enter new password"
                required
              />
            </div>

            <div className="auth-field">
              <label htmlFor="confirmPassword">Confirm new password</label>
              <input
                id="confirmPassword"
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm new password"
                required
              />
            </div>

            <button
              type="submit"
              className="auth-submit-button"
              disabled={submitting}
            >
              {submitting ? "Resetting..." : "Reset password"}
            </button>
          </form>

          <p className="auth-switch-text">
            Didn't get a code?{" "}
            <Link to="/forgot-password">Request a new one</Link>
          </p>

          <p className="auth-switch-text">
            Remembered your password? <Link to="/login">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordForm;
